import { find, findAll, register } from '../../../Javascript/Utils'

const component = el => {
  const componentPrefix = el.dataset.componentprefix
  const metaMenu = find(`.${componentPrefix}metaNav`, el)
  const mainMenu = find(`.${componentPrefix}mainNav`, el)
  const metaNavHeight = metaMenu.offsetHeight
  const subMenuFirstLevel = findAll(`.${componentPrefix}hasSubmenu`, el)

  subMenuFirstLevel.forEach(element => {
    element.addEventListener('mouseenter', function (e) {
      e.currentTarget.children[1].classList.add(`${componentPrefix}submenu-active`)
    })
    element.addEventListener('mouseleave', function (e) {
      e.currentTarget.children[1].classList.remove(`${componentPrefix}submenu-active`)
    })
  })

  document.addEventListener('scroll', () => {
    if ((window.pageYOffset > metaNavHeight)) {
      mainMenu.classList.add(`${componentPrefix}mainNav-scrolled`)
    } else {
      mainMenu.classList.remove(`${componentPrefix}mainNav-scrolled`)
    }
  })
}

register('header', component)
